module.exports = __webpack_public_path__ + "img/festlager_teaser.6d2c4105.png";